module.exports = __webpack_public_path__ + "static/media/03.Ravana Darbar.992ecb16.JPG";